import React, { useEffect, useState } from 'react';

import {
  LogoMTRFullWhite,
  FaviconMTRWhite,
  LogoMTREnterpriseFullWhite,
  FaviconMTREnterpriseWhite,
} from '@dsny/dsny-component-library';
import { getEnterprisePlanFromLocalStorage } from 'src/utils/LocalStorageManager';
import { useSelector } from 'react-redux';
import { RootState } from 'src/app/store';
import { LogoWrapper, NavLinkWrapper } from './Sidebar.styles';

type SidebarFooterProp = {
  to: string;
  isExpanded: boolean;
  onClick: () => void;
};

const SidebarLogo = ({ isExpanded, onClick }: SidebarFooterProp) => {
  const [isEnterprise, setIsEnterprise] = useState(undefined);

  const { enterpriseProfile } = useSelector(
    (state: RootState) => state.dashboard
  );

  useEffect(() => {
    setIsEnterprise(getEnterprisePlanFromLocalStorage());
  }, [enterpriseProfile]);

  if (isEnterprise === undefined) {
    return null;
  }

  return (
    <>
      <LogoWrapper $isExpanded={isExpanded}>
        <NavLinkWrapper tabIndex={0} to="" onClick={onClick}>
          {/* Desktop enterprise logo */}
          {isEnterprise && isExpanded && <LogoMTREnterpriseFullWhite />}
          {isEnterprise && !isExpanded && <FaviconMTREnterpriseWhite />}

          {/* Desktop default logo */}
          {!isEnterprise && isExpanded && <LogoMTRFullWhite />}
          {!isEnterprise && !isExpanded && <FaviconMTRWhite />}
        </NavLinkWrapper>
      </LogoWrapper>
    </>
  );
};

export default SidebarLogo;
